export default __webpack_public_path__ + "static/moneyAnt-70c677276a82e9d5689b07e459112b9f.png";